'use client';

import type { Column, Table } from '@tanstack/react-table';
import { ChevronDown, ChevronsUpDown, ChevronUp } from 'lucide-react';
import { cn } from '@/utils/ui-utils';

interface SortButtonProps<TData, TValue> {
  column: Column<TData, TValue>;
  table?: Table<TData>;
  isSorted: 'asc' | 'desc' | false;
  className?: string;
}

const SortButton = <TData, TValue>({ column, table, isSorted, className = '' }: SortButtonProps<TData, TValue>) => {
  return (
    // biome-ignore lint/a11y/useSemanticElements: SortButton renders inside the sortable header cell's <button> (see Table/index.tsx), so it cannot be a real <button> — nesting one causes a hydration error (button-in-button). It stays a role=button div.
    // biome-ignore lint/a11y/useKeyWithClickEvents: keyboard sorting is provided by the header-cell button that wraps this indicator; this element's onClick is a mouse-only convenience.
    <div
      role='button'
      tabIndex={0}
      onClick={(e) => {
        const toggleHandler = column.getToggleSortingHandler?.();
        toggleHandler?.(e);
        table?.firstPage();
      }}
      className={cn('inline-flex items-center justify-center', className)}
    >
      {
        {
          asc: (
            <ChevronUp
              strokeWidth={2}
              size={10}
            />
          ),
          desc: (
            <ChevronDown
              strokeWidth={2}
              size={10}
            />
          ),
          false: (
            <ChevronsUpDown
              strokeWidth={2}
              size={10}
            />
          ),
        }[isSorted as string]
      }
    </div>
  );
};
export default SortButton;
